export const userTypes = {
  CLIENTE: 'CLIENTE',
  FORNECEDOR: 'FORNECEDOR',
  LICENCIADO: 'LICENCIADO',
  PUBLICO: 'PUBLICO'
};
